// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1Sm3n","signatureButtonsRight":"ModalSign_signatureButtonsRight__27ccd"};